import { MenuItem, Typography } from "@mui/material";
import React from "react";
import { Box, Button, Menu, FormControl, Select, InputLabel } from "@mui/material";
import Fade from "@mui/material/Fade";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { CheckoutCards } from "../Checkout_Dishes/CheckoutCards";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Link,
  Divider,
  Drawer,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { CheckoutMainCard } from "../Checkout_Dishes/CheckoutMainCard";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  AllMealsAction,
  JuiceAction,
  MainCourseAction,
  SlideAction,
} from "Redux/actions";
import Swal from "sweetalert2";
import { CheckoutAddon } from "components/Checkout_Dishes/CheckoutAddOn";

const Subscription = (
  // { mainCourse, juice, data, slide }
) => {
  // console.log("Main course", mainCourse);
  // console.log("Juice", juice);
  // console.log(data);
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const { selectedDishes } = useSelector((state) => state.dishes)
  const { selectedAddon } = useSelector((state) => state.addOns)
  console.log(selectedDishes)
  console.log("selectedAddon", selectedAddon)


  const [anchorEl, setAnchorEl] = React.useState(null);
  // const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    console.log(event.currentTarget)
  };
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  const [state1, setState1] = React.useState({
    right: false,
  });

  const toggleDrawer1 = (anchor, open) => (event) => {
    // console.log(anchor);
    // console.log(open);
    // if (mainCourse > 0 || juice > 0 || slide > 0) {
    //   dispatch(MainCourseAction(mainCourse));
    //   dispatch(JuiceAction(juice));
    //   dispatch(SlideAction(slide));
    //   dispatch(AllMealsAction(mealArr));
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState1({ ...state1, [anchor]: open });
    // } else {
    //   Swal.fire("Error", "Select Dishes First..", "error");
    // }
  };

  const list = (anchor) => (
    <Box
      sx={{
        width:
          anchor === "top" || anchor === "bottom"
            ? "auto"
            : { lg: "708px", md: "708px", sm: "auto", xs: "auto" },
      }}
      role="presentation"
      onClick={toggleDrawer1(anchor, false)}
      onKeyDown={toggleDrawer1(anchor, false)}
    >
      <Box sx={{ paddingLeft: "24px" }}>
        <Box>
          <List>
            <ListItem disablePadding>
              <ListItemButton
                sx={{
                  width: "20px",
                  height: "76px",
                  color: "#000000",
                  fontSize: { lg: "24px", md: "24px", sm: "22px", xs: "18px" },
                  fontWeight: "600",
                }}
              >
                <ListItemIcon>
                  <CloseIcon sx={{ color: "#E75C62" }} />
                  <ListItemText
                    sx={{
                      paddingRight: {
                        lg: "246px",
                        md: "246px",
                        sm: "246px",
                        xs: "40px",
                      },
                      color: "#000000",
                    }}
                  />{" "}
                  Your Basket
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </List>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            // paddingLeft: "24px",
            paddingTop: "0px",
            marginTop: "0px",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontWeight: "400",
                fontSize: { lg: "18px", md: "18px", sm: "16px", xs: "16px" },
                paddingRight: "12px",
              }}
            >
              Order from
            </Typography>
          </Box>

          <Box>
            <Link
              component="button"
              sx={{
                fontWeight: "600",
                fontSize: { lg: "18px", md: "18px", sm: "16px", xs: "16px" },
              }}
            >
              Chef Juna Food
            </Link>
          </Box>
        </Box>
        <Box // ml="24px"
          sx={{
            display: "flex",
            flexDirection: "row",
            marginTop: "24px",
            paddingLeft: "24px",
            // border:"1px solid red"
          }}
        >
          <CheckoutMainCard />
        </Box>

        <Divider />

        <Box>
          <Box>
            <Typography
              sx={{
                fontSize: { lg: "24px", md: "24px", sm: "20px", xs: "18px" },
                fontWeight: "600",
                marginTop: "16px",
                // marginBottom: "16px",
              }}
            >
              Meal Courses
            </Typography>

            <Box
              sx={{
                // paddingLeft: "30px",
                // paddingBottom: "211.93px",
                // border: "1px solid red",
              }}
            >
              <CheckoutCards
                selectedDishes={selectedDishes}
              />
            </Box>
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: { lg: "24px", md: "24px", sm: "20px", xs: "18px" },
                fontWeight: "600",
                marginTop: "16px",
                // marginBottom: "16px",
              }}
            >
              Add-Ons
            </Typography>

            <Box
              sx={{
                // paddingLeft: "30px",
                // paddingBottom: "211.93px",
                // border: "1px solid red",
              }}
            >
              <CheckoutAddon
                selectedAddon={selectedAddon}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            p: 2,
          }}
        >
          <Button
            variant="contained"
            fullWidth
            size="large"
            sx={{
              textTransform: "capitalize",
              // size: { lg: "large", md: "large", sm: "medium", xs: "small" },
              fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
              fontWeight: "600",
              height: "48px",
              marginBottom: "24px",
            }}
            onClick={() => navigate("/subscriptiontype")}
          >
            Checkout
          </Button>
        </Box>
      </Box>
    </Box>
  );

  // const placeOrderNow = () => {};
  const handleType = (e) => {
    console.log(e.target.value)
  }
  const [age, setAge] = React.useState('');
  const [open, setOpen] = React.useState(false);

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);

  };


  return (
    <Box>
      <Box>
        <Box
          sx={{
            width: "100%",
            border: "1px solid #E1E1E6",
            borderRadius: "6px",
            height: "auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              margin: "20px",
            }}
          >
            {/* <Box>

            </Box> */}

            <Box>
              <Box sx={{
                display: "flex", flexDirection: "column",
                // border: "1px solid red"
              }}>

                {/* <Button sx={{ color: "#9EA3AE", width: "210px", textTransform: "capitalize" }} onClick={handleOpen} endIcon={<KeyboardArrowDownIcon />} >
                  {age ? age : "Select Subscription"}
                </Button> */}
                {/* <FormControl sx={{ m: 1, minWidth: 120 ,display:"none" }}> */}
                {/* <InputLabel id="demo-controlled-open-select-label">Age</InputLabel> */}
                {/* <Select
                  labelId="demo-controlled-open-select-label"
                  id="demo-controlled-open-select"
                  open={open}
                  onClose={handleClose}
                  onOpen={handleOpen}
                  value={age}
                  // label="Age"
                  onChange={handleChange}
                  // renderValue={(selected) => {
                  //   if (selected.length === 0) {
                  //     return <em>Placeholder</em>;
                  //   }

                  //   return selected.join(', ');
                  // }}
                  // MenuProps={MenuProps}
                  inputProps={{ 'aria-label': 'Without label' }}
                  sx={{
                    height: "0vh",
                    display: `${open ? "block" : "none"}`,
                    border: "none"

                    // display: "none"
                  }}
                >

                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={"Weekly Subscription"}>Weekly Subscription</MenuItem>
                  <MenuItem value={"Monthly Subscription"}>Monthly Subscription</MenuItem>
                  <MenuItem value={"Single Subscription"}>Single Subscription</MenuItem>
                </Select> */}


                {/*     <Button
                sx={{ color: "#9EA3AE" }}
                endIcon={<KeyboardArrowDownIcon />}
                onClick={handleClick}
              >
                Weekly Subscription
              </Button>
              <Menu
                id="fade-menu"
                MenuListProps={{
                  "aria-labelledby": "fade-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                TransitionComponent={Fade}
                sx={{ fontSize: "16px", fontWeight: "400" }}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
              >
                <MenuItem onClick={handleClose}>Monthly Subscription</MenuItem>
                <MenuItem onClick={handleClose}>Weekly Subscription</MenuItem>
                <MenuItem onClick={handleClose}>Single Order</MenuItem>
                <MenuItem onClick={handleClose}>Custom Subscription</MenuItem>
              </Menu> */}


              </Box>
              {/* <Box>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "35px",
                  }}
                >
                  $112.21
                </Typography>
              </Box> */}
            </Box>
            <Box>
              <Button
                onClick={toggleDrawer1("right", true)}
                variant="contained"
              >
                Place Order Now
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
      <Drawer
        anchor={"right"}
        open={state1["right"]}
        onClose={toggleDrawer1("right", false)}
      >
        {list("right")}
      </Drawer>
    </Box >
  );
};

export default Subscription;
